import {
  Account,
  Dashboard,
  Stables,
  StablesComprar,
  StablesVender,
  StablesSwap,
  StablesSacar,
  StablesDepositar,
  StablesHistorico,
  StablesLimits,
  ContaInternacional,
  ContaInternacionalDetalhe,
  ContaInternacionalDepositar,
  ContaInternacionalMovimentar,
  ContaInternacionalTransferir,
  Crossborder,
  CrossborderCustomers,
  CrossborderCustomerProfile,
  Cartoes,
  Extract,
  Payments,
  PayOffice,
  PixArea,
  PixPayment,
  PixSales,
  PixTransfer,
  PixTransferMockPreview,
  PixKeys,
  PixLimits,
  PixDetalhes,
  PixLotesPage,
  PixLoteDetailPage,
  Receipts,
  Tickets,
} from "../Pages/Private";

import { Support } from "../Pages/Private";
import { TransactionalPassword } from "../Pages/Private/Account/TransactionalPassword";
import { MdOutlinePix } from "react-icons/md";
import {
  TbCoins,
  TbBuildingBank,
  TbBuildingStore,
  TbCashBanknote,
  TbCreditCard,
  TbHeadset,
  TbLayoutDashboard,
  TbList,
  TbReceipt,
  TbReceiptRefund,
  TbReportMoney,
  TbSettings,
  TbTicket,
  TbUser,
  TbUserPlus,
  TbUsers,
  TbWorld,
  TbArrowsExchange,
  TbHierarchy2,
  TbWallet,
} from "react-icons/tb";
import { PermissionId } from "../Contexts/AuthContext";
import { Redirect } from "react-router-dom";
import { Organizers } from "../Pages/Private/Organizers";
import DetailsOrganizer from "../Pages/Private/Organizers/Details";
import { PaymentDetails } from "../Pages/Private/PayOffice/tabs/payments/details";
import { Refunds } from "../Pages/Private/Refunds";
import { AddTicket } from "../Pages/Private/Tickets/AddTicket";
import { BaasConsoleApp } from "../Pages/Private/BaasConsole";
import { CarteiraUsersPage } from "../Pages/Private/Users";
import { VirtualAccountsPage } from "../Pages/Private/VirtualAccounts";

/** Sidebar groups: Conta (IB) → gestão → Produtos (console). */
export type MenuSectionId =
  | "conta"
  | "gestao"
  | "produtos";

export type IbProductFeatureCode = "pix" | "cards" | "stables" | "fiat" | "carteira";

export interface IMenuRoute {
  path: string;
  label?: string;
  labelKey?: string;
  icon?: any;
  exact?: boolean
  isHidden?: boolean;
  comingSoon?: boolean;
  badge?: string;
  badgeKey?: string;
  menuSection?: MenuSectionId;
  permission?: PermissionId
  /** Instance/entity product gate (e.g. pix=0 hides Área Pix). */
  requiredFeature?: IbProductFeatureCode
  /**
   * Show only when login `can_access_console` is true (person linked to a BaaS
   * instance — owner person/entity membership via BaasApiInstanceUsers).
   */
  requiresConsoleAccess?: boolean
  /**
   * Hide from IB sidebar when the active account is an exit-rail VIRTUAL (WALLET/OTC).
   * Create virtual only from matriz/operacional.
   */
  hideWhenExitRailVirtual?: boolean
  /** Hide menu + block deep-link for viewer / visualizador (read-only session). */
  hideWhenReadOnly?: boolean
  component: () => JSX.Element
}

export const routes: IMenuRoute[] = [
  {
    path: "/",
    labelKey: "nav.home",
    menuSection: "conta",
    permission: "statementsview",
    component: () => <Dashboard />,
    icon: TbLayoutDashboard,
  },
  {
    path: "/extrato",
    labelKey: "nav.extract",
    menuSection: "conta",
    permission: "statementsview",
    component: () => <Extract />,
    icon: TbList,
  },
  {
    path: "/stables/comprar",
    label: "Comprar stablecoins",
    permission: "stablesoperate",
    requiredFeature: "stables",
    component: () => <StablesComprar />,
    isHidden: true,
  },
  {
    path: "/stables/vender",
    label: "Vender stablecoins",
    permission: "stablesoperate",
    requiredFeature: "stables",
    component: () => <StablesVender />,
    isHidden: true,
  },
  {
    path: "/stables/swap",
    label: "Swap stablecoins",
    permission: "stablesoperate",
    requiredFeature: "stables",
    component: () => <StablesSwap />,
    isHidden: true,
  },
  {
    path: "/stables/sacar",
    label: "Sacar stablecoins",
    permission: "stablesoperate",
    requiredFeature: "stables",
    component: () => <StablesSacar />,
    isHidden: true,
  },
  {
    path: "/stables/depositar",
    label: "Depositar stablecoins",
    permission: "stablesoperate",
    requiredFeature: "stables",
    component: () => <StablesDepositar />,
    isHidden: true,
  },
  {
    path: "/stables/limites",
    label: "Limites transacionais Stables",
    permission: "stablesview",
    requiredFeature: "stables",
    component: () => <StablesLimits />,
    isHidden: true,
  },
  {
    path: "/stables/historico",
    permission: "stablesview",
    requiredFeature: "stables",
    component: () => <Redirect to="/stables" />,
    isHidden: true,
  },
  {
    path: "/stables/historico/:historyTab",
    permission: "stablesview",
    requiredFeature: "stables",
    component: () => <StablesHistorico />,
    isHidden: true,
  },
  {
    path: "/stables",
    labelKey: "nav.stables",
    badgeKey: "common.new",
    menuSection: "conta",
    permission: "stablesview",
    requiredFeature: "stables",
    component: () => <Stables />,
    icon: TbCoins,
  },
  {
    path: "/conta-internacional",
    labelKey: "nav.internationalAccount",
    badgeKey: "common.new",
    menuSection: "conta",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <ContaInternacional />,
    icon: TbWorld,
  },
  {
    path: "/conta-internacional/crossborder/customers",
    label: "Crossborder Customers",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <CrossborderCustomers />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/crossborder/customers/:customerId",
    label: "Crossborder Customer Profile",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <CrossborderCustomerProfile />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/crossborder/payin",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Redirect to="/conta-internacional/crossborder?modal=payin" />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/crossborder/payout",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Redirect to="/conta-internacional/crossborder?modal=payout" />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/crossborder",
    label: "Crossborder",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Crossborder />,
    icon: TbArrowsExchange,
    isHidden: true,
  },
  {
    path: "/conta-internacional/:currencyId/depositar",
    label: "Depositar conta internacional",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <ContaInternacionalDepositar />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/:currencyId/movimentar",
    label: "Movimentar conta internacional",
    permission: "internationaltransfer",
    requiredFeature: "fiat",
    component: () => <ContaInternacionalMovimentar />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/:currencyId/transferir",
    label: "Transferir conta internacional",
    permission: "internationaltransfer",
    requiredFeature: "fiat",
    component: () => <ContaInternacionalTransferir />,
    isHidden: true,
  },
  {
    path: "/conta-internacional/:currencyId",
    label: "Detalhe conta internacional",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <ContaInternacionalDetalhe />,
    isHidden: true,
  },
  {
    path: "/crossborder/payin",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Redirect to="/conta-internacional/crossborder?modal=payin" />,
    isHidden: true,
  },
  {
    path: "/crossborder/payout",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Redirect to="/conta-internacional/crossborder?modal=payout" />,
    isHidden: true,
  },
  {
    path: "/crossborder",
    permission: "internationalview",
    requiredFeature: "fiat",
    component: () => <Redirect to="/conta-internacional/crossborder" />,
    isHidden: true,
  },
  {
    path: "/pix",
    labelKey: "nav.pixArea",
    menuSection: "conta",
    permission: "pixview",
    requiredFeature: "pix",
    component: () => <PixArea />,
    icon: MdOutlinePix,
  },
  {
    path: "/contas-virtuais",
    labelKey: "nav.virtualAccounts",
    menuSection: "conta",
    permission: "virtualaccountsview",
    hideWhenExitRailVirtual: true,
    component: () => <VirtualAccountsPage />,
    icon: TbWallet,
  },
  {
    path: "/transferencia",
    permission: "p2pview",
    component: () => <Redirect to={{ pathname: "/", search: "transfer=1" }} />,
    isHidden: true,
  },
  {
    path: "/pagamento",
    labelKey: "nav.payments",
    menuSection: "conta",
    permission: "payboleto",
    comingSoon: true,
    component: () => <Payments />,
    icon: TbCashBanknote,
  },
  {
    path: "/boletos",
    permission: "boletocreateview",
    labelKey: "nav.tickets",
    menuSection: "conta",
    comingSoon: true,
    component: () => <Tickets />,
    icon: TbTicket,
  },
  {
    path: "/boletos/add",
    permission: "boletocreateview",
    label: "Criar Boleto",
    isHidden: true,
    component: () => <AddTicket />,
  },
  {
    path: "/comprovantes",
    labelKey: "nav.receipts",
    menuSection: "conta",
    permission: "receiptsview",
    component: () => <Receipts />,
    icon: TbReceipt,
  },
  {
    path: "/estornos",
    labelKey: "nav.refunds",
    menuSection: "conta",
    permission: "refundsview",
    component: () => <Refunds />,
    icon: TbReceiptRefund,
  },
  {
    path: "/payroll",
    labelKey: "nav.payroll",
    menuSection: "gestao",
    permission: "admin",
    isHidden: true,
    component: () => <Redirect to="/" />,
    icon: TbReportMoney,
  },
  {
    path: "/pontos-de-venda",
    labelKey: "nav.organizers",
    menuSection: "gestao",
    permission: "admin",
    isHidden: true,
    component: () => <Organizers />,
    icon: TbBuildingStore,
  },
  {
    path: "/usuarios",
    labelKey: "nav.users",
    menuSection: "gestao",
    permission: "operatorsview",
    hideWhenReadOnly: true,
    component: () => <CarteiraUsersPage />,
    icon: TbUsers,
  },
  {
    path: "/operadores",
    labelKey: "nav.operators",
    menuSection: "gestao",
    permission: "admin",
    isHidden: true,
    component: () => <Redirect to="/usuarios" />,
    icon: TbUserPlus,
  },
  {
    path: "/perfil",
    labelKey: "nav.profile",
    menuSection: "gestao",
    isHidden: true,
    component: () => <Account />,
    icon: TbUser,
  },
  {
    path: "/suporte",
    labelKey: "nav.support",
    menuSection: "gestao",
    isHidden: true,
    component: () => <Support />,
    icon: TbHeadset,
  },
  {
    path: "/configuracoes",
    labelKey: "nav.settings",
    menuSection: "gestao",
    isHidden: true,
    component: () => <Account />,
    icon: TbSettings,
  },
  {
    path: "/cartoes",
    labelKey: "nav.cards",
    badgeKey: "common.new",
    menuSection: "gestao",
    permission: "mycardview",
    requiredFeature: "cards",
    component: () => <Cartoes />,
    icon: TbCreditCard,
  },
  {
    path: "/baas",
    labelKey: "nav.baas",
    badgeKey: "common.new",
    menuSection: "produtos",
    permission: "statementsview",
    requiresConsoleAccess: true,
    exact: false,
    component: () => <BaasConsoleApp />,
    icon: TbHierarchy2,
  },
  {
    path: "/meus-cartoes",
    label: "Meu cartão",
    requiredFeature: "cards",
    component: () => <Redirect to="/cartoes" />,
    isHidden: true,
    icon: TbCreditCard,
  },
  {
    path: "/pontos-de-venda/:subAccountId",
    label: "Detalhes do PV",
    component: () => <DetailsOrganizer />,
  },
  {
    path: "/pay-office",
    label: "Pagadoria",
    exact: false,
    isHidden: true,
    component: () => <PayOffice />,
    permission: "admin",
    icon: TbBuildingBank,
  },
  {
    path: "/pay-office/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})",
    exact: true,
    component: () => <PaymentDetails />,
  },
  {
    path: "/payroll/:id",
    label: "Detalhes do arquivo de folha de pagamento",
    isHidden: true,
    component: () => <Redirect to="/" />,
  },
  // legacy operator create/edit routes removed; handled via modal in Operators page

  {
    path: "/pix/transferencia/preview",
    label: "Transferência Pix (mock)",
    isHidden: true,
    requiredFeature: "pix",
    component: () => <PixTransferMockPreview />,
  },
  {
    path: "/pix/transferencia",
    label: "Transferência Pix",
    permission: "paypix",
    requiredFeature: "pix",
    component: () => <PixTransfer />,
  },
  {
    path: "/pix/copia-cola",
    label: "Pix copia e cola",
    permission: "paypix",
    requiredFeature: "pix",
    component: () => <PixPayment />,
  },
  {
    path: "/pix/vendas",
    label: "Receber por Pix",
    isHidden: true,
    permission: "receivepix",
    requiredFeature: "pix",
    component: () => <PixSales />,
  },
  {
    path: "/pix/detalhes",
    label: "Gestão de vendas Pix",
    isHidden: true,
    permission: "receivepix",
    requiredFeature: "pix",
    component: () => <PixDetalhes />,
  },
  {
    path: "/pix/limites",
    label: "Limites transacionais Pix",
    isHidden: true,
    requiredFeature: "pix",
    component: () => <PixLimits />,
  },
  {
    path: "/pix/contestacao",
    label: "Contestação de Pix (MED)",
    isHidden: true,
    permission: "pixview",
    requiredFeature: "pix",
    comingSoon: true,
    component: () => <Redirect to="/pix" />,
  },
  {
    path: "/pix/lotes",
    label: "Lotes Pix",
    permission: "pixview",
    requiredFeature: "pix",
    isHidden: true,
    component: () => <PixLotesPage />,
  },
  {
    path: "/pix/lotes/:batchId",
    label: "Detalhe lote Pix",
    permission: "pixview",
    requiredFeature: "pix",
    isHidden: true,
    component: () => <PixLoteDetailPage />,
  },
  {
    path: "/pix/keys",
    label: "Chaves Pix",
    permission: "pixview",
    requiredFeature: "pix",
    component: () => <PixKeys />,
  },
  {
    path: "/anticipation",
    labelKey: "nav.anticipation",
    menuSection: "gestao",
    isHidden: true,
    component: () => <Redirect to="/" />,
    permission: "admin",
    icon: TbReportMoney,
  },
  {
    path: "/anticipation/addInvoice",
    label: "Adicionar Notas Fiscais",
    isHidden: true,
    component: () => <Redirect to="/" />,
  },
  {
    path: "/anticipation/buyers",
    label: "Compradores",
    isHidden: true,
    component: () => <Redirect to="/" />,
  },
  {
    path: "/anticipation/duplicates",
    label: "Duplicatas",
    isHidden: true,
    component: () => <Redirect to="/" />,
  },
  {
    path: "/perfil/senha-transacional",
    labelKey: "profile.transactionalPassword",
    component: () => <TransactionalPassword />,
    isHidden: true,
  },
  // DEFAULT ROUTE
  {
    path: "*",
    component: () => <Dashboard />,
    isHidden: true,
  }
];
